import React from 'react';
import { ArrowBackRounded } from '@mui/icons-material';
import { AuthLayout, OtpInputField, SupportLink } from '../../components';
import { AlertDialog } from '../../components/AlertDialog';
import {
  BackButton,
  Heading,
  Title,
  SubTitle,
  Destination,
  CodeArea,
  StatusText,
  ErrorText,
  ResendRow,
  ResendHint,
  ResendButton,
} from './styles';

const dialogTitle = '¿No te llegó el código?';
const dialogSubtitle = 'Si no tienes WhatsApp, puedes recibirlo por SMS.';
const mainbuttonTitle = 'SMS';
const secondarybuttonTitle = 'WhatsApp';
const sentByTexts = {
  whatsapp: 'Te enviamos un código de 4 dígitos por WhatsApp al',
  telefono: 'Te enviamos un código de 4 dígitos por SMS al',
  correo: 'Te enviamos un código de 4 dígitos al correo',
};

// +573001234567 → +57 300 123 4567, para que sea fácil de reconocer.
const formatDestination = (valor = '') => {
  const match = valor.match(/^(\+\d{2})(\d{3})(\d{3})(\d{4})$/);
  return match ? match.slice(1).join(' ') : valor;
};

function VerifyCodeOtp({
  handleCloseDialog,
  handleSubmitDialog,
  userInformation,
  sentBy,
  handleSubmit,
  handleChange,
  remainTime,
  errorMsgs,
  code,
  openDialog,
  verifying,
  onBack,
}) {
  const time = remainTime();
  const canResend = time === '0:00';
  const isPhone = userInformation?.medio === 'telefono';

  return (
    <AuthLayout>
      <AlertDialog
        mainbuttonTitle={mainbuttonTitle}
        secondarybuttonTitle={secondarybuttonTitle}
        title={dialogTitle}
        subtitle={dialogSubtitle}
        openAlert={openDialog}
        selectedVehicleData={{}}
        handleCloseAlert={handleCloseDialog}
        handleAceptAlert={handleSubmitDialog}
        handleCancelAlert={handleSubmitDialog}
      />
      <BackButton startIcon={<ArrowBackRounded />} onClick={onBack}>
        {isPhone ? 'Cambiar número' : 'Cambiar correo'}
      </BackButton>
      <Heading>
        <Title component="h1">Ingresa el código</Title>
        <SubTitle>
          {sentByTexts[sentBy] || sentByTexts.correo}
          {' '}
          <Destination>{formatDestination(userInformation?.valor)}</Destination>
        </SubTitle>
      </Heading>
      <CodeArea>
        <OtpInputField
          code={code}
          handleChange={handleChange}
          hasError={Boolean(errorMsgs)}
          disabled={verifying}
        />
        <div aria-live="polite">
          {verifying ? <StatusText>Verificando…</StatusText> : null}
          {!verifying && errorMsgs ? <ErrorText role="alert">{errorMsgs}</ErrorText> : null}
        </div>
      </CodeArea>
      <ResendRow>
        {canResend ? (
          <ResendButton onClick={handleSubmit}>Reenviar código</ResendButton>
        ) : (
          <ResendHint>
            ¿No te llegó? Puedes pedir otro en
            {' '}
            <strong>{time}</strong>
          </ResendHint>
        )}
      </ResendRow>
      <SupportLink onDark valor={userInformation?.valor} />
    </AuthLayout>
  );
}

export default VerifyCodeOtp;
